/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RetryFailedPspNotificationsDto
 */
export interface RetryFailedPspNotificationsDto {
    /**
     * 
     * @type {Array<number>}
     * @memberof RetryFailedPspNotificationsDto
     */
    pspNotificationIds: Array<number>;
}

/**
 * Check if a given object implements the RetryFailedPspNotificationsDto interface.
 */
export function instanceOfRetryFailedPspNotificationsDto(value: object): value is RetryFailedPspNotificationsDto {
    if (!('pspNotificationIds' in value) || value['pspNotificationIds'] === undefined) return false;
    return true;
}

export function RetryFailedPspNotificationsDtoFromJSON(json: any): RetryFailedPspNotificationsDto {
    return RetryFailedPspNotificationsDtoFromJSONTyped(json, false);
}

export function RetryFailedPspNotificationsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RetryFailedPspNotificationsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'pspNotificationIds': json['pspNotificationIds'],
    };
}

export function RetryFailedPspNotificationsDtoToJSON(json: any): RetryFailedPspNotificationsDto {
    return RetryFailedPspNotificationsDtoToJSONTyped(json, false);
}

export function RetryFailedPspNotificationsDtoToJSONTyped(value?: RetryFailedPspNotificationsDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'pspNotificationIds': value['pspNotificationIds'],
    };
}

